module.exports = __webpack_public_path__ + "media/images/ibu__icon__burgerMenu-d6cebfe82446f2a2d35f2a0d4891c0af.svg";